/**
 * THE ALMANAC, ON THE PHONE — the reason offline is possible here at all.
 *
 * FOUNDER, 2026-08-10: "yes it needs to work offline at sea."
 *
 * The instinct when you hear that is to cache API responses, and for an almanac that instinct is a
 * trap: you would be shipping a TABULATION, and a tabulation has an edge. Download a year and the
 * candidate is fine until the year runs out, at sea, with no way to fetch another — which is the
 * failure mode of the paper almanac, faithfully reproduced in software for no reason.
 *
 * The ephemeris is not data. It is ~170 KB of VSOP87/ELP series that COMPUTE the sky, and it was
 * already plain JavaScript because it had to run on the server. So it ships, and then the phone can
 * work a sight for any instant, forever, with no download, no expiry and no span to choose. This is
 * FP-010 exactly: the reliable floor is the one with no dependency, and here the floor is arithmetic.
 *
 * WHAT IS DELIBERATELY EXPOSED ON globalThis, AND WHY. The cross-engine gate has to compare what the
 * BROWSER computes against what the SERVER computes, to the digit — two ephemerides that disagree is
 * worse than no ephemeris, because one of them is lying to a cadet and neither says which. A gate
 * that tested a special build would be testing something nobody ships. So the shipped bundle hands
 * the gate a handle on the real thing. See almanac-cross-engine.mjs.
 */
import { almanacBody } from '../../../almanac-body.mjs';

/** The same page /api/almanac returns, computed here. Identical shape, by construction: one builder. */
export function localAlmanac({ date, stars = 8, lat = null, lon = null } = {}) {
  return almanacBody({ date: date || new Date().toISOString(), stars, lat, lon });
}

/* The handle the cross-engine gate reaches for. Reading it costs nothing and it is not a capability
   the page did not already have — the same function is what the offline almanac calls. */
globalThis.__ankrLocalAlmanac = localAlmanac;

export default localAlmanac;
